module.exports = __webpack_public_path__ + "static/media/chiapas_montebello_trigosuave_10.8dae52c9.png";